import clsx from "clsx"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { SpinnerCircular } from "spinners-react"
import { useModal } from "@/modals"
import { STORE_ITEM_TYPES, useGetStoreQuery } from "@/store/apis/storeAPI"
import { Button } from "@/ui/Button"
import { Modal } from "@/ui/Modal"
import { OutlinedText } from "@/ui/OutlinedText"
import styles from "./MatchGoldCards.module.scss"
import { MatchGoldCardItem } from "./ui/MatchGoldCardItem/MatchGoldCardItem"

const modalType = "matchGoldCards"

export const MatchGoldCards: FC = () => {
  const { modal } = useModal(modalType)
  const { t } = useTranslation()

  const { data: store, isLoading } = useGetStoreQuery({
    page: 1,
    limit: 50,
    type: STORE_ITEM_TYPES.CARD,
    populate: true
  })

  const cards = store?.items ?? []

  const handleClose = () => {
    modal.close()
  }

  return (
    <Modal.Center
      type={modalType}
      className={clsx(styles.MatchGoldCards)}
      body={{ className: styles.MatchGoldCards_body }}
    >
      <Modal.StoneFlexContainer
        className={styles.MatchGoldCards_container}
        content={{ className: styles.MatchGoldCards_content }}
        outside={
          <div className={clsx(styles.MatchGoldCards_footerButtons)}>
            <Button
              className={clsx(styles.MatchGoldCards_footerButtons_item)}
              styles="green"
              onClick={handleClose}
            >
              {t("button.close")}
            </Button>
          </div>
        }
      >
        <OutlinedText className={clsx(styles.MatchGoldCards_title)}>
          {t("modals.matchGoldCards.title")}
        </OutlinedText>

        {isLoading && cards.length === 0 && (
          <div className={clsx(styles.MatchGoldCards_state)}>
            <SpinnerCircular size={32} color="#35262699" />
          </div>
        )}

        {!isLoading && cards.length === 0 && (
          <div className={clsx(styles.MatchGoldCards_state)}>
            {t("modals.matchGoldCards.empty")}
          </div>
        )}

        {cards.length > 0 && (
          <div className={clsx(styles.MatchGoldCards_list)}>
            {cards.map((cardItem) => (
              <MatchGoldCardItem {...cardItem} key={cardItem._id} />
            ))}
          </div>
        )}
      </Modal.StoneFlexContainer>
    </Modal.Center>
  )
}
